import React, { memo } from 'react'

// html editor
import HTMLEditor from 'utlis/helpers/HTMLEditor'

function FormBlogs__Description(props) {
    const { getResult, formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <div className={`st-form st-form-with-label-left d-flex flex-wrap mb-3 ${(formik.touched.blogDescription && formik.errors.blogDescription) ? "has-msg msg-error" : ""}`}>
                <label>
                    Content
                </label>
                <div className="media-body">
                    <HTMLEditor
                        defaultValue={formik.values.blogDescription}
                        getResult={getResult}
                    />

                    {
                        /* form message */
                        (formik.touched.blogDescription && formik.errors.blogDescription) && (
                            <div className="st-form-msg position-absolute" style={{ bottom: -18 }}>
                                <p className="st-fs-12">{formik.errors.blogDescription}</p>
                            </div>
                        )
                    }
                </div>
            </div>
        </React.Fragment>
    )
}


export default memo(FormBlogs__Description)